import { Button, MagellanPopup } from 'components/atoms';
import { useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PiQuestion } from 'react-icons/pi';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IDeliveryDiscrepancyPopupProps {
  trigger?: JSX.Element;
  disabledTrigger?: boolean;
  name?: string;
  onGoToDelivery?: (actions: PopupActions) => void;
  cancelLoading?: boolean;
  transI18nKey?: string;
  isClear?: boolean;
}

const DeliveryDiscrepancyPopup = ({
  trigger,
  disabledTrigger,
  name = '',
  onGoToDelivery,
  cancelLoading,
  isClear = true,
}: IDeliveryDiscrepancyPopupProps) => {
  const { t } = useTranslation();
  const popupRef = useRef<PopupActions>(null);
  return (
    <Popup
      ref={popupRef}
      modal
      nested
      trigger={
        trigger ?? (
          <Button
            isClear={isClear}
            onlyIcon
            variant={BUTTON_VARIANT.warning}
            disabled={disabledTrigger}>
            <Button.Icon icon={<PiQuestion />} />
          </Button>
        )
      }>
      <MagellanPopup>
        <MagellanPopup.Header className='justify-center'>
          <PiQuestion />
          {t(`popup.header`)}
        </MagellanPopup.Header>
        <div className='flex flex-col opacity-55 max-w-96 text-center gap-4'>
          <p>
            <Trans
              i18nKey={'popup.delivery-discrepancy'}
              values={{ name: name }}
              components={{ strong: <strong /> }}
            />
          </p>
          <p>{t(`popup.delivery-discrepancy-question`)}</p>
        </div>
        <div className='flex gap-2 mt-4'>
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t(`popup.close`)} />
          </Button>
          {onGoToDelivery && (
            <Button
              variant={BUTTON_VARIANT.warning}
              onClick={() =>
                onGoToDelivery &&
                popupRef.current &&
                onGoToDelivery(popupRef.current)
              }
              isLoading={cancelLoading}>
              <Button.Text text={t(`popup.go-to-delivery`)} />
            </Button>
          )}
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default DeliveryDiscrepancyPopup;
